import React, { useState, useEffect, useCallback } from 'react';
import {Modal, Button, Badge} from 'react-bootstrap';
import LoginForm from './LoginForm';
import LoadingSpinner from './LoadingSpinner';
import useLoadingState from '../utils/useLoadingState';
import Logo from "./shiftLogo.png";
import '../styles/loginPage.css';
import TermsContent from "./termsContent";
import PrivacyContent from "./privacyContent";
import ContactContent from "./contactContent";
import { auth, provider, signInWithPopup } from "../firebase";
import { FaRegComments, FaUserCircle } from 'react-icons/fa'; // Import icons

const LoginPage = ({ handleLogin }) => {
    const { isLoading, handleLoadingState } = useLoadingState();
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [error, setError] = useState('');

    const handleLoginWithLoading = useCallback(async (credentials) => {
        await handleLoadingState(() => handleLogin(credentials));
    }, [handleLogin, handleLoadingState]);

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const token = await user.getIdToken(); // Get the user's ID token
            localStorage.setItem('token', token); // Store the token
            handleLogin(user); // Pass the user info to the parent component
        } catch (error) {
            console.error("Google sign-in error:", error.message);
            setError('Google sign-in failed. Please try again later.');
        }
    };

    useEffect(() => {
    }, [handleLogin]);

    const handleCloseModal = () => {
        setShowTermsModal(false);
        setShowPrivacyModal(false);
        setShowContactModal(false);
    };

    return (
        <div className="login-page">
            <div className="login-panel">
                <img src={Logo} alt="LazyWa" className="login-logo" />
                <h5 className="login-subtitle">Your gateway to effortless communication.</h5>
                <div className="free-to-use-badge">Free to Use</div>

                <p className="login-description">
                                 </p>

                <div className="features">
                    <div className="feature-icon">
                        <FaRegComments size={50} />
                        <p>Personalized Messages</p>
                    </div>
                    <div className="feature-icon">
                        <FaUserCircle size={50} />
                        <p>Real-Person Help</p>
                    </div>
                </div>

                <LoginForm onLogin={handleLoginWithLoading} />

                {error && <p className="text-danger">{error}</p>}
            </div>

            {isLoading && <LoadingSpinner />}

            <Modal show={showTermsModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Terms of Service</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TermsContent />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPrivacyModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Privacy Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PrivacyContent />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showContactModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Contact Us</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ContactContent />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default LoginPage;
